import React, { useEffect, useState } from 'react';
import styles from '../styles/survey.module.css';
import { TagManagerUtils } from '../../../utils/TagManagerUtils';
import { appInsights } from '../../../components/azureAppInsights/azureAppInsights';
import featuresData from '../data/thirdSlide.json';
import FeaturesCarousell from './FeaturesCarousell';

const SurveyFeatures = ({ dataId, familyLink }) => {

    const [priceId, setPriceId] = useState('');
    const [trial, setTiral] = useState(0);
    const surveyData = featuresData.slideThree;
    const featuresArray = surveyData.filter((item) => item.id === dataId);


    useEffect(() => {
        async function getPackage() {
            let params = new URLSearchParams(document.location.search.substring(1));
            let forceCountryCode = params.get('forceCountryCode');
            let additionalParams = '';
            if (forceCountryCode) {
                additionalParams = "&forceCountryCode=" + forceCountryCode
            }
            appInsights.trackEvent({ name: 'getPackage', properties: { forceCountryCode: forceCountryCode, productId: process.env.REACT_APP_PUBLIC_STRIPE_PRODUCT_ID } });
            const res = await fetch(process.env.REACT_APP_PUBLIC_PAYMENT_URL + 'checkout/package?productid=' + process.env.REACT_APP_PUBLIC_STRIPE_PRODUCT_ID + additionalParams)

            if (!res.ok) {
                // This will activate the closest `error.js` Error Boundary
                appInsights.trackException({ exception: new Error('Failed to fetch package data') }, { statusText: res.statusText, status: res.status });
                throw new Error('Failed to fetch package data')
            }

            let data = await res.json();
            let price = data.prices[0];
            localStorage.setItem('currency', price.currency);
            localStorage.setItem('amountPaid', price.amount);
            localStorage.setItem('priceId', price.id);
            console.log('localStorage set', {
                'amountPaid': price.amount,
                'currency': price.currency,
                'priceId': price.id
            });
            appInsights.trackTrace({ message: 'Package data fetched', properties: data });
            TagManagerUtils.sendEventWithEcommerceData('onCheckoutView');
        }

        getPackage();
    }, [trial]);

    function initStripeSession(email) {
        let params = new URLSearchParams(document.location.search.substring(1));
        let forceCountryCode = params.get('forceCountryCode');
        appInsights.trackEvent({ name: 'initStripeSession', properties: { email: email, forceCountryCode: forceCountryCode } });
        console.log("initStripe Session email: ", email);
        fetch(process.env.REACT_APP_PUBLIC_PAYMENT_URL + 'checkout/session',
            {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify({
                    email: email,
                    priceId: priceId,
                    returnPage: "/",
                    trial: trial,
                    productId: process.env.REACT_APP_PUBLIC_STRIPE_PRODUCT_ID,
                    forceCountryCode: forceCountryCode
                }),
            }
        )
            .then(response => response.json()) // no content
            .then(data => {

                if (localStorage.getItem('priceId') === '' && data.price) {
                    let price = data.price;
                    setPriceId(price.id);
                    localStorage.setItem('currency', price.currency);
                    localStorage.setItem('amountPaid', price.amount);
                    localStorage.setItem('priceId', price.id);
                }

                localStorage.setItem('userId', data.userId);
                localStorage.setItem('email', email);

                console.log('localStorage set', {
                    'userId': data.userId,
                    'email': email
                });

                window.dataLayer = window.dataLayer || [];

                window.dataLayer.push({
                    'event': 'userData',
                    'user_id': data.userId
                });

                TagManagerUtils.sendEventWithEcommerceData('onEmailSubmit');

                if (data.isPaid && data.code) {
                    window.location.replace("/welcome");
                    return;
                }

                if (data.checkoutUrl) {
                    window.location = data.checkoutUrl;
                }
            })
            .catch((error) => {
                appInsights.trackException({ exception: new Error('Failed to fetch session data') }, { error: error });
                console.log("there was an error")
                console.error(error)
            });
    }

    return (
        <div className={styles.mainFeatureContainer}>
            <h2 className={styles.header}>Our features, especally<br />for you</h2>
            <FeaturesCarousell featuresArray={featuresArray[0].features} initStripeSession={initStripeSession} />
        </div>
    )
}

export default SurveyFeatures